import { COMMON_QUERY_PARAMS } from "taskpane/constants/queryParams";
import { ICommonQueryParams, IConferenceQueryResult, IQueryResponse } from "taskpane/models/interfaces";
import useQuery from "./useQuery";
import { encodeUriParams } from "taskpane/utils";
import { QueryType, StartSessionStatusCode } from "taskpane/models/enums";
import { OnReady } from "taskpane/models/types";
import getQueryErrorTryAgainLater from "taskpane/resources/getQueryErrorTryAgainLater";
import { getQueryErrorDeauthorization } from "taskpane/resources";

interface IStartSessionQueryParams extends ICommonQueryParams {
  ts: number;
  a: string;
  userSn: string;
  events: string;
  sessionTimeout: number;
}

export interface IStartSession {
  token: string;
  email: string;
  apiUrl: string;
}

export interface IStartSessionResponse {
  response: {
    statusCode: number;
    statusText: string;
    data: {
      aimsid?: string;
    };
  };
}

const useQueryStartSession = (
  params: IStartSession,
  onReady: OnReady<IConferenceQueryResult<IStartSessionResponse>>
) => {
  const { token, email, apiUrl } = params;
  const sysdate: number = Date.now();
  const url: string = `${apiUrl}/wim/aim/startSession`;
  const queryParams: IStartSessionQueryParams = {
    ...COMMON_QUERY_PARAMS,
    ts: sysdate,
    a: token,
    userSn: email,
    events: "myInfo",
    sessionTimeout: 30,
  };

  useQuery(
    `${url}${encodeUriParams(queryParams)}`,
    "POST",
    ({ response, errorMessage, statusCode }: IQueryResponse<IStartSessionResponse>) => {
      const result: IConferenceQueryResult<IStartSessionResponse> = {
        queryType: QueryType.startSession,
        errorMessage: "",
        statusCode,
        response,
      };

      if (errorMessage) {
        result.errorMessage = errorMessage;
      } else {
        const responseStatusCode: number = response.response.statusCode;

        if (responseStatusCode === StartSessionStatusCode.notAuthorized) {
          result.errorMessage = getQueryErrorDeauthorization();
        } else if (responseStatusCode !== StartSessionStatusCode.successed) {
          result.errorMessage = getQueryErrorTryAgainLater("при попытке начать сессию");
        }
      }

      onReady(result);
    }
  );
};

export default useQueryStartSession;
